import styled from 'styled-components';

export const ReviewItem = styled.div``;

export interface ReviewBlockProps {
  layout?: 'column' | 'rows';
}

export const StyledReviewBlock = styled.div<ReviewBlockProps>`
  ${ReviewItem} + ${ReviewItem} {
    margin-top: 32px;
  }

  ${props =>
    props.layout === 'column' &&
    ` ${ReviewItem} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        h2 {
          flex-shrink: 0;
          line-height: 24px;
          margin-right: 18px;
          width: 100px;
        }
      }
    `}
`;
